import PropTypes from 'prop-types'
import { memo } from 'react'
import ListItemComponent from '../../../../stories/molecules/list-items'
import { iconSizeOptions } from '../../../../stories/atoms/icons/icons-sizes'
import StatusIndicationComponent from '../../../../stories/atoms/status-indication'
import { statusIndicationMemberVariantOptions } from '../../../../stories/atoms/status-indication/constants'
import { getContactIdentityFields } from '../../../../../utils/get-contact-identity-fields'

const ContactItem = ({ item }) => {
  const { primary, secondary } = getContactIdentityFields(item)

  return (
    <ListItemComponent.Item
      itemKey={item.id}
      leadingIcon={
        <StatusIndicationComponent
          size={iconSizeOptions['ICON-L']}
          variant={statusIndicationMemberVariantOptions.CONTACT}
          iconNotEnclosed
        />
      }
      title={primary}
      secondaryText={secondary}
      style={{ borderRadius: 0, border: 0 }}
      noPadding
    />
  )
}

ContactItem.propTypes = {
  item: PropTypes.object
}

const MemoizedContactItem = memo(ContactItem)
MemoizedContactItem.displayName = 'ContactItem'

export default MemoizedContactItem
